/* tslint:disable */
/* eslint-disable */
/**
 * ROC API
 * Referral Outbound Center (ROC) API for managing outbound referrals between post-acute care facilities.  All endpoints require a valid JWT. Organization and user identity are derived from the token — callers never pass these in query params or request bodies. 
 *
 * The version of the OpenAPI document: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateReadReceiptRequest
 */
export interface UpdateReadReceiptRequest {
    /**
     * 
     */
    last_read_message_id: string;
}

/**
 * Check if a given object implements the UpdateReadReceiptRequest interface.
 */
export function instanceOfUpdateReadReceiptRequest(value: object): value is UpdateReadReceiptRequest {
    if (!('last_read_message_id' in value) || value['last_read_message_id'] === undefined) return false;
    return true;
}

export function UpdateReadReceiptRequestFromJSON(json: any): UpdateReadReceiptRequest {
    return UpdateReadReceiptRequestFromJSONTyped(json, false);
}

export function UpdateReadReceiptRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateReadReceiptRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'last_read_message_id': json['last_read_message_id'],
    };
}

export function UpdateReadReceiptRequestToJSON(json: any): UpdateReadReceiptRequest {
    return UpdateReadReceiptRequestToJSONTyped(json, false);
}

export function UpdateReadReceiptRequestToJSONTyped(value?: UpdateReadReceiptRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'last_read_message_id': value['last_read_message_id'],
    };
}

